import {Component, OnInit, ViewChild} from '@angular/core';
import {CentreService} from "../../../../services/centre.service";
import {EducationService} from "../../education.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ChildService} from "../../../../components/child/child.service";
import {Observable} from "rxjs";
import {Centre} from "../../../../interfaces/Centres";
import {FullChild} from "../../../../interfaces/FullChild";
import { FormControl, FormGroup, Validators} from "@angular/forms";
import {MatSelect, MatSelectChange} from "@angular/material/select";
import {CentreSelection} from "../../../counseling/components/add-group-session/add-group-session.component";
import { MatDialogRef} from "@angular/material/dialog";
import {MatOption} from "@angular/material/core";
import {TitleCasePipe} from "@angular/common";
import {LogService} from "../../../../services/log.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";

@Component({
    selector: 'app-add-group-education',
    templateUrl: './add-group-education.component.html',
    styleUrls: ['./add-group-education.component.scss']
})
export class AddGroupEducationComponent implements OnInit {
    centres$: Observable<Centre[]>
    docpath = 'educationGroupTest/'
    dbType: any = 'firestore'
    formSaved = false
    allSelected = false;
    mVolunteers$:Observable<any>
    userData = JSON.parse(localStorage.getItem('userData')!)
    storagePath = 'EducationDocs'
    children$?: Observable<FullChild[]>
    selectedCentreCode!: string
    allChildrens?: any[]
    selectedCentreName!: string
    startTimeValue: any
    endTimeValue: any
  maxDate=new Date()
    form!: FormGroup
    centreSelect: FormControl = new FormControl('', Validators.required)
    childSelect: FormControl = new FormControl('', Validators.required)
    childrensArr: any[] = []
    selectedChildrens: any[] = []
    displayedColumns: String[] = ['childName', 'centreName', 'Action'];
    showVolunteerName = false

    @ViewChild('select') select?: MatSelect;

    constructor(readonly centreService: CentreService,
                readonly eduationService: EducationService,
                readonly matSnackBar: MatSnackBar,
                private titlecasePipe: TitleCasePipe,
                private readonly mLogService:LogService,
                private readonly  mDatabase: AngularFireDatabase,


                readonly matDialogRef: MatDialogRef<AddGroupEducationComponent>,
                readonly childService: ChildService) {
        this.centres$ = centreService.getAllCentres()
        this.mVolunteers$ =  this.mDatabase.list('types/Volunteers').valueChanges()

    }

    ngOnInit(): void {
        this.initForm()
    }

    private initForm() {
        this.form = new FormGroup({
            centres: new FormControl('', Validators.required),
            children: new FormControl('', Validators.required),
            sessionType: new FormControl('', Validators.required),
            sessionDate: new FormControl('', Validators.required),
            topicsCovered: new FormControl('', Validators.required),
            sessionDetails: new FormControl('', Validators.required),
            // remark: new FormControl('', Validators.required),
            subject: new FormControl('', Validators.required),
            // present: new FormControl('', Validators.required),
            startTime: new FormControl('', Validators.required),
            volunteerName: new FormControl(''),
            endTime: new FormControl('', Validators.required),
            conductedBy: new FormControl(''),
            countType: new FormControl(''),
            submittedBy: new FormControl({value: this.userData.userName, disabled: true}, Validators.required),

            createdAt: new FormControl(new Date()),
            // absentReason: new FormControl('', absentConditionallyRequiredValidator)
        })
        // this.form.get('gender')?.disable()
    }

    onCentreSelectOld($event: any) {
        this.selectedCentreCode = $event.value.centreCode
        this.selectedCentreName = $event.value.centreName
        this.children$ = this.childService.getAllotedChildListByCenterAboveThree(this.selectedCentreCode)
        this.children$.subscribe(res => {
            this.selectedChildrens = res
            this.allChildrens = res

        })

        this.CenterName?.setValue($event.value.centreName)
        this.CentreCode?.setValue(this.selectedCentreCode)
    }


    get startTime() {
        return this.form.get('startTime')
    }

    get ChildUnit() {
        return this.form.get('unitCode')
    }

    get endTime() {
        return this.form.get('endTime')
    }

    get ChildGender() {
        return this.form.get('gender')
    }

    get ChildName() {
        return this.form.get('childName')
    }

    get ChildCode() {
        return this.form.get('childCode')
    }

    get CenterName() {
        return this.form.get('centreName')
    }

    get CentreCode() {
        return this.form.get('centreCode')
    }

   //* Invokes when centre is created
    onCentreSelect($event: MatSelectChange) {
        this.allSelected =true
        let centres = $event.value as CentreSelection[]
      console.log('On Centre Select',$event.value)
        let centreCodes: string[] = []
        let centreNames: string[] = []
        let allcentres: any[] = []
        centres.forEach(v => {
            centreCodes.push(v.centreCode)
            centreNames.push(v.centreName)
            allcentres.push({
                centreName: v.centreName,
                centreCode: v.centreCode
            })
        })

        console.log(centreCodes)
        console.log(centreNames)
        // alert(centre)
  if(centres.length>=1) {
    this.children$ = this.childService.getAllotedChildListByCenterArrayAboveThree(centreCodes)
this.selectedChildrens=[]
    // this.children$.subscribe(res => {
    //   res.forEach(it => {
    //     this.selectedChildrens.push({
    //       'childCode': it.childCode,
    //       'gender': it.gender,
    //       'unitCode': it.selectUnit,
    //       'childName': it.firstName + ' ' + it.lastName,
    //       "status": "Present",
    //       "isFollowUp": "No"
    //     })
    //
    //   })
    // })


    this.form.get('centres')?.setValue(allcentres)

  }
  else this.selectedChildrens=[]
    }

    onChildSelect($event: MatSelectChange) {
        let children = $event.value as FullChild[]
        let childrens: any[] = []
        let childNames: string[] = []
        children.forEach(v => {
            childrens.push({
                'childCode': v.childCode,
              // 'age':v.age,
                'gender': v.gender,
                'unitCode': v.selectUnit,
                'childName': v.firstName + ' ' + v.lastName,
                "status": "Present",
                "isFollowUp":v.admissionData.length>2? 'Yes' : 'No'
            })
            childNames.push(v.firstName + " " + v.lastName)
            // let p = (v.guardians[0]?.firstName +' and '+v.guardians[1]?.firstName).toString()
            // console.log('p',p)
            // this.parents?.push(p)
            // console.log(this.parents)
        })

        // this.form.get('childCodes')?.setValue(childCodes)
        // this.form.get('childNames')?.setValue(childNames)
        this.form.get('children')?.setValue(childrens)
        // @ts-ignore
        this.selectedChildrens = childrens
        this.form.get('children')?.setValue(this.selectedChildrens)
    }

    Submit() {
        this.form.get('children')?.setValue(this.selectedChildrens)

        if (this.form.valid) {
            this.eduationService.addGroupEducationSession(this.form.getRawValue()).then(res => {
                this.matSnackBar.open('Submitted Successfully')._dismissAfter(3000)
              let activity={
                date:new Date().getTime(),
                section: 'Group Education',
                action: 'Submit',

                description: 'Group Session added to Education by user ',
                currentIp: localStorage.getItem('currentip')!
              }
              this.mLogService.addLog(activity)
                this.matDialogRef.close()
            })
        } else {
            this.matSnackBar.open('Please these fields :  ' + this.findInvalidControls())._dismissAfter(3000)

        }
    }

    public findInvalidControls() {
        const invalid = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        return invalid;
    }

    AddPresent(id: any, value: any, element1: any) {
        element1['status'] = value
    }

    isFollowUpChild(id: any, value: any, element1: any) {
        element1['isFollowUp'] = value
    }

    close() {
        this.matDialogRef.close()
    }

    onBlur(formControl: any) {
        if(formControl.value !== null) {
            formControl.setValue(this.titlecasePipe.transform(formControl.value.toString().trim().toUpperCase()))
        }
    }

    optionClick() {
        let newStatus = true;
        this.select?.options.forEach((item: MatOption) => {
            if (!item.selected) {
                newStatus = false;
            }
        });
        this.allSelected = newStatus;
    }

    toggleAllSelection() {
        if (this.allSelected) {
            this.select?.options.forEach((item: MatOption) => item.select());
        } else {
            this.select?.options.forEach((item: MatOption) => item.deselect());
        }
    }

    removeChild(index: number, c: any) {
     this.selectedChildrens = this.selectedChildrens.filter((c,i)=>i!=index)

    }
    OnConductedByChange($event: MatSelectChange) {
        if ($event.value === 'By Teacher') {
            this.showVolunteerName = false;
            this.form.get('volunteerName')?.setValue('')
        } else if ($event.value === 'By Volunteer') {
            this.showVolunteerName = true;
        }
    }
}
// function absentConditionallyRequiredValidator(formControl: AbstractControl) {
//   if (!formControl.parent) {
//     return null;
//   }
